<script lang="ts">import { Button } from "@infinitro/button";
import { cfgToThemeCdnPath, stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { isMobile, ModalDialog, pushModal } from "@infinitro/global";
import { Text } from "@infinitro/text";
import assets from "../assets";
/* assets */
/** Generic/Wild Ape resolve these directly here instead of through the per-brand assets.ts
* dispatch (kept for legacy brands only). */
const useNeutralAssets = $stateUi.vip?.useNeutralAssetPaths ?? false;
const RoyaltyBannerBackground = useNeutralAssets ? cfgToThemeCdnPath("/about-refer-and-earn/banner-background.png") : assets.royaltyBanner;
const RoyaltyBannerBackgroundMobile = useNeutralAssets ? cfgToThemeCdnPath("/about-refer-and-earn/banner-background-mobile.png") : assets.royaltyBannerMobile;
const handleSignUp = () => {
	pushModal(ModalDialog.Auth, { tab: "signup" });
};
</script>

<div class="banner-section">
	<div class="royalty-banner">
		<div class="banner-card">
			<img
				src={!!RoyaltyBannerBackgroundMobile && $isMobile
					? RoyaltyBannerBackgroundMobile
					: RoyaltyBannerBackground}
				alt={$t(Verbiage.banner_background_alt, 'alts')}
				class="banner-background"
			/>
			<div class="card-content">
				<Text
					type="body"
					bodySize="large"
					bodyWeight="black"
					textColor="primary"
					customStyle="font-size: 14px !important; text-transform: uppercase;"
					fontFamily="main"
				>
					{$t(Verbiage.welcome_to_vip_club_text)}
				</Text>
				<div class="banner-title">
					<Text
						type="title"
						titleSize="h2"
						fontFamily="alternative-2"
						titleWeight="bold"
						customStyle="font-size: 40px !important; line-height: 48px !important;"
						textAlign={$isMobile ? 'center' : 'start'}
					>
						{$t(Verbiage.ready_to_text)}
						<span class="highlight">{$t(Verbiage.become_royalty_text)}</span>
					</Text>
				</div>
				<div class="banner-title-mobile">
					<div class="banner-title-mobile-text">
						<Text
							type="title"
							titleSize="h4"
							fontFamily="alternative-2"
							titleWeight="bold"
							customStyle="font-size: 32px !important; line-height: 48px !important;"
							textAlign="center"
						>
							{$t(Verbiage.ready_to_text)}
							<span class="highlight">{$t(Verbiage.become_royalty_text)}</span>
						</Text>
					</div>
				</div>
				<div class="button-container">
					<Button text={$t(Verbiage.register)} fullWidth onClick={handleSignUp} />
				</div>
			</div>
		</div>
	</div>
</div>

<style>
	.banner-section {

		height: auto;

		width: 100%
}

	.royalty-banner {

		position: relative;

		height: 300px;

		width: 100%
}

	.banner-card {

		position: relative;

		height: 100%;

		width: 100%;

		overflow: hidden;

		border-radius: 1rem;

		--tw-text-opacity: 1;

		color: rgb(255 255 255 / var(--tw-text-opacity, 1));

		font-family: var(--font-main)
}

	.card-content {

		position: relative;

		z-index: 10;

		display: flex;

		height: 100%;

		width: 100%;

		flex-direction: column;

		align-items: center;

		justify-content: space-between;

		gap: 1rem;

		padding: 2rem
}

	.banner-background {

		position: absolute;

		z-index: 10;

		height: 100%;

		width: auto;

		border-radius: 1rem
}

	.highlight {

		color: var(--color-primary-500)
}

	.banner-title {

		display: none;

		height: 50%;

		align-items: center
}

	.banner-title-mobile {

		display: flex;

		height: 50%;

		width: 100%;

		align-items: center;

		justify-content: center
}

	.banner-title-mobile-text {

		width: 235px;

		text-align: center
}

	.button-container {

		width: 100%
}

	@media (min-width: 1024px) {
		.royalty-banner {

				height: 259px
		}

		.card-content {

				align-items: flex-start;

				justify-content: center
		}

		.banner-background {

				width: 100%;

				max-width: none
		}

		.banner-title {

				display: flex;

				width: 460px
		}

		.banner-title-mobile {

				display: none
		}

		.button-container {

				width: 115px
		}
	}

	@media (min-width: 1280px) {
		.card-content {

				width: 75%
		}
	}

	@media (max-width: 1024px) {
		.banner-background {

				right: 0px;

				transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
		}
	}
</style>
